import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

// Code-splitting (§перф): тяжёлые/редкие страницы грузятся отдельными чанками по
// требованию, а не одним бандлом на старте. Login и Dashboard — eager (вход и
// дефолтный лендинг), остальное — lazy. Снижает первый JS-пакет по плечу Бали↔РФ.
const Advertising  = lazy(() => import('./pages/Advertising'));
const Crm          = lazy(() => import('./pages/Crm'));
const Bookings     = lazy(() => import('./pages/Bookings'));
const Transactions = lazy(() => import('./pages/Transactions'));
const Reports      = lazy(() => import('./pages/Reports'));
const Settings     = lazy(() => import('./pages/Settings'));
const Users        = lazy(() => import('./pages/Users'));
const BankImport   = lazy(() => import('./pages/BankImport'));
const AuditLog     = lazy(() => import('./pages/AuditLog'));
const Payroll      = lazy(() => import('./pages/Payroll'));
const Breakfasts   = lazy(() => import('./pages/Breakfasts'));
const Investors    = lazy(() => import('./pages/Investors'));

const PageFallback = () => (
  <div style={{ padding: 24, color: '#888' }}>Загрузка…</div>
);

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard"    element={<Dashboard />} />
            <Route path="/crm"          element={<Suspense fallback={<PageFallback />}><Crm /></Suspense>} />
            <Route path="/advertising"  element={<Suspense fallback={<PageFallback />}><Advertising /></Suspense>} />
            <Route path="/bookings"     element={<Suspense fallback={<PageFallback />}><Bookings /></Suspense>} />
            <Route path="/transactions" element={<Suspense fallback={<PageFallback />}><Transactions /></Suspense>} />
            <Route path="/bank-import"  element={<Suspense fallback={<PageFallback />}><BankImport /></Suspense>} />
            <Route path="/payroll"      element={<Suspense fallback={<PageFallback />}><Payroll /></Suspense>} />
            <Route path="/breakfasts"   element={<Suspense fallback={<PageFallback />}><Breakfasts /></Suspense>} />
            <Route path="/reports"      element={<Suspense fallback={<PageFallback />}><Reports /></Suspense>} />
            <Route path="/investors"    element={<Suspense fallback={<PageFallback />}><Investors /></Suspense>} />
            <Route path="/audit"        element={<Suspense fallback={<PageFallback />}><AuditLog /></Suspense>} />
            <Route path="/settings"     element={<Suspense fallback={<PageFallback />}><Settings /></Suspense>} />
            <Route path="/users"        element={<Suspense fallback={<PageFallback />}><Users /></Suspense>} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
